import type { AssetValue } from '../../services/productApi';

export function chipUrl(value: AssetValue | undefined): string | undefined {
	return value?.['finish-chip']?.url ?? value?.swatch?.url;
}
